<template>
    <div class="my-ohc-tours">
        <BlocksMyOhcNav @viewToggle="setView" />
        <section class="favorites-and-intineraries-wrapper hd-container">
            <BlocksTurquoiseAlert v-if="(!loading && !userTours.length) || !tours.length" :type="'tours'" />
            <div class="my-favorites-wrapper">
                <section class="tours">
                    <BlocksToursList :showHeader="false" :items="tours" v-if="tours.length"></BlocksToursList>
                </section>
            </div>
        </section>
    </div>
</template>

<script setup>
    // Libraries
    import { storeToRefs } from 'pinia';

    // Stores
    import { useUserStore } from '@/stores/user';
    import { useToursStore } from '@/stores/tours';

    // Variables
    const mapView = ref(true);
    const userStore = useUserStore();
    const { tours: userTours } = storeToRefs(userStore);

    // Computed
    const tours = computed(() => {
        if (userTours.value.length) {
            return toursDataStore.value.filter((el) => {
                return userTours.value.includes(el.id);
            });
        }
        return [];
    });

    function setView(view) {
        mapView.value = view;
    }

    // Tours Store
    const loading = ref(true);
    const { toursData } = storeToRefs(useToursStore());
    const toursDataStore = computed(() => toursData.value?.records);
</script>

<style lang="scss" scoped>
    .my-ohc-tours {
        max-width: $hd;
        margin: auto;
        min-height: 400px;
        padding-top: 16px;        

        .favorites-and-intineraries-wrapper {
            z-index: 0;
            position: relative;
        }

        @media (min-width: $tablet) {
            max-width: $hd;
            margin: auto;

            .tours-list {
                padding: 0 0 30px 0;
            }
        }
    }
</style>
